import React from "react";

function SectionHead({ eyebrow, title, subtitle, center = false }) {
  return (
    <div className={`section-head ${center ? "section-head--center" : ""}`}>
      {eyebrow && (
        <span className="eyebrow">
          <span className="eyebrow-dot" aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <h2 className="section-title">{title}</h2>
      {subtitle && <p className="section-subtitle">{subtitle}</p>}
    </div>
  );
}

export default SectionHead;
